<template>
    <div>
        <el-tabs v-model="curGenre">
            <el-tab-pane v-for="tab in pgenre" :label="tab.name" :name="tab.key" :key="tab.key"></el-tab-pane>
        </el-tabs>
        <div class="flex items-center justify-between">
            <div class="flex items-center">
                <div v-for="tab in tabs" :key="tab.key" class="text-sm tab cursor-pointer text-sm"
                    :class="{ 'active': curTab == tab.key }" @click="curTab = tab.key">
                    {{ tab.name }}
                    <span class="text-xs">({{ tab.num }})</span>

                </div>
                <el-button type="primary" size="small" class="ml-4 mr-4" @click="showSelect = true"
                    v-if="curGenre == 'bundled'">
                    <span class="pr-1">+</span>{{ $t('新增商品') }}
                </el-button>
                <el-button type="primary" size="small" class="ml-4 mr-4" @click="isBatch = !isBatch">
                    <span class="iconfont icon-piliang pr-1"></span>{{ $t('批量操作') }}
                </el-button>


            </div>
            <Search :placeholder="$t('商品名称/关键词')" @search="search"></Search>
        </div>
        <div class="titles tr" :class="{ 'bundled': curGenre == 'bundled' }">
            <div class="text-left pl-4">
                <el-checkbox :value="isSelectAll" @change="selectAll">全选</el-checkbox>
            </div>
            <div v-for="(title, index) in titles" :key="index">{{ title }}</div>
        </div>
        <div class="tr product" v-for="item in pager.items" :key="item.id"
            :class="{ 'bundled': curGenre === 'bundled' }">
            <div class="img-box">
                <el-checkbox v-model="item._select"></el-checkbox>
                <img :src="$firstImage(item.images, 'small')" class="img">
                <span class="text-base text-left">{{ item.name }}</span>
                <span class="text-sm text-gray-400 attrs">{{ item.attribute_text }}</span>
            </div>

            <div class="text-sm">
                <span>{{ item.stock }}</span>
            </div>
            <div class="text-sm">
                <span>{{ $p(item.rawprice) }}</span>
            </div>

            <div class="text-sm">
                <span v-if="item.rule" class="rule">{{ item.rule.name }}</span>
            </div>
            <div class="text-sm">
                <span>{{ item.price }}</span>
            </div>
            <div class="text-sm ">
                <span style="color: #FF4142" v-if="item.status == 0">{{ $t('待上架') }}</span>
                <span style="color: #10BC56;" v-else-if="item.status == 10">{{ $t('上架中') }}</span>
            </div>
            <div v-if="curGenre == 'bundled'">
                <el-link v-if="item.bundles" style="color: #407CFF;text-decoration: underline;" :underline="false"
                    @click="curRproduct = item, isShowRproducts = true">{{ item.bundles.length }}</el-link>
            </div>
            <div class="text-sm  cursor-pointer flex-col" :class="{ 'bundled': item.is_bundled }">
                <span v-if="item.status == 0 && !item.is_bundled" @click.stop="doShelves(item)" style="color: #407CFF;">
                    {{ $t('上架') }}
                </span>
                <span v-else-if="item.status == 0 && item.is_bundled && item.bundles && item.bundles.length"
                    @click.stop="doShelves(item)" style="color: #407CFF;">
                    {{ $t('上架') }}
                </span>
                <span @click.stop="doShelves(item)" v-else-if="item.status == 10" style="color: #407CFF;">
                    {{ $t('下架') }}
                </span>
                <span style="color: #407CFF;" @click="addPrice(item.id)">{{ $t('改加价') }}</span>
                <template v-if="item.is_bundled">
                    <span style="color: #407CFF;" @click="setProduct(item, 'stock')">{{ $t('改库存') }}</span>
                    <span style="color: #407CFF;" @click="setProduct(item, 'edit')">{{ $t('编辑') }}</span>
                </template>
                <span style="color:#FF4747" @click.stop="doShelves(item, 'lock')" v-if="item.status != -1">{{ $t('锁定')
                    }}</span>
                <!-- <span style="color:#FF4747" @click.stop="doShelves(item, 'unlock')" v-else-if="item.status == -1">{{
                    $t('解锁') }}</span> -->




                <!-- <span style="color:#FF4747" @click="delProduct(item.id)">{{ $t('删除') }}</span> -->

            </div>

        </div>
        <div class="flex justify-end items-center pt-5" v-if="isBatch">
            <el-button v-for="btn in batchBtns" :key="btn.id" :type="btn.type" @click="setBatch(btn.key)">{{ btn.name
                }}</el-button>
        </div>
        <el-pagination background layout="prev, pager, next" :total="pager.total" :page-size="pager.size"
            @current-change="pageChange" v-if="pager.total" class="mt-6">
        </el-pagination>
        <div v-else class="mt-60">
            <img :src="require(`@/assets/image/暂无收藏.png`)" class="mx-auto" />
        </div>
        <el-dialog title="" :visible.sync="isRulesEdit">
            <div class="flex justify-between items-center">
                <el-tabs v-model="curRuleTab">
                    <el-tab-pane v-for="tab in ruleTabs" :label="tab.name" :name="tab.key" :key="tab.key"></el-tab-pane>
                </el-tabs>
                <Search :placeholder="$t('搜索关键词')" @search="searchRule"></Search>

            </div>
            <div class="rules">
                <div v-for="item in rulePager.items" :key="item.id" class="rule grid ">
                    <div class="px-5 truncate w-full text-left self-center py-2">
                        <span>{{ item.name }}</span>
                        <template v-if="item.rules_text">
                            <span class="text-gray-500 pl-6 text-sm">{{ $t('仓储费设置') }}</span>
                            <span class="text-red-600 pl-2 text-sm" v-for="(r, index) in item.rule_list" :key="index">{{
                                `${$p(r.min)}~${$p(r.max)}:${$p(r.exp)}`
                            }}</span>
                        </template>
                    </div>
                    <div class=" border-l-2 h-full flex-center py-2">
                        <div class=" edit cursor-pointer" @click="setEdit(item.id)">
                            <span class="iconfont icon-bianji1"></span>
                            {{ $t('编辑') }}
                        </div>
                        <el-button type="primary" size="small" class="ml-4 mr-4" @click="apply(item.id)">
                            {{ $t('应用') }}
                        </el-button>
                    </div>
                </div>
                <el-pagination background layout="prev, pager, next" :total="rulePager.total"
                    @current-change="loadMoreRules" v-if="rulePager.total"></el-pagination>
                <div v-else class="mt-6">
                    <img :src="require(`@/assets/image/暂无收藏.png`)" class="mx-auto" />
                </div>
            </div>
        </el-dialog>
        <el-dialog title="" :visible.sync="isShowRproducts" destroy-on-close>
            <div>
                <div class="main-product">
                    <img :src="$firstImage(curRproduct.images, 'small')">
                    <span class="text-base font-semibold">{{ curRproduct.name }}</span>
                    <span class="text-sm text-gray-400 attrs">{{ curRproduct.attribute_text }}</span>
                    <span class="text-sm" v-if="curRproduct.bundles">{{ $t('关联商品') }}*{{ curRproduct.bundles.length
                    }}</span>
                </div>
                <div class="r-table">
                    <div class="r-tr th">
                        <span v-for="(title, index) in subTitles" :key="index">{{ title }}</span>
                    </div>
                    <div class="r-tr td" v-for="i in curRproduct.bundles" :key="i.id">
                        <span>{{ i.name }}</span>
                        <span>{{ i.quantity }}</span>
                        <span class="price">{{ $p(i.rawprice) }}</span>
                        <span class="flex-col flex">
                            <!-- <span style="color: #407CFF;">{{ $t('调整数量') }}</span> -->
                            <span style="color: #FF4747;" @click="delRproduct(index)">{{ $t('删除') }}</span>
                        </span>
                    </div>
                </div>
                <div class="mt-4">
                    <el-button @click="isShowRproducts = false">{{ $t('返回') }}</el-button>
                    <el-button type="primary" @click="selectRproduct">+{{ $t('新增关联商品') }}</el-button>

                </div>
            </div>
            <el-dialog :visible.sync="isRproductEdit" append-to-body >
                <div class="flex justify-between items-center">
                    <div class="pproducts">
                        <span v-for="i in pproducts" :key="i.id">{{ i.name }}</span>
                    </div>
                    <Search :placeholder="$t('商品名称/关键词')" @search="searchOutProudct"></Search>
                </div>
                <div class="out-table">
                    <div class="out-tr th">
                        <span class="justify-self-start pl-5">
                            {{ $t('商品') }}
                            <!-- <el-checkbox :value=""></el-checkbox> -->
                        </span>
                        <span v-for="(title, index) in outTitles" :key="index">{{ title }}</span>
                    </div>
                    <div v-for="item in outPager.items" :key="item.id" class="out-tr td">
                        <div>
                            <el-checkbox v-model="item.selected" @change="setRproduct(item, $event)"></el-checkbox>
                            <img :src="$firstImage(item.images, 'small')">
                            <span class="name">{{ item.name }}</span>
                            <span class="attrs">{{ item.attribute_text }}</span>
                        </div>
                        <div>{{ $p(item.price) }}</div>
                        <div>
                            {{ item.stock }}
                        </div>
                        <div>
                            <el-input-number size="small" @change="setRproductNum(item, $event)" v-model="item.quantity"
                                :min="0"></el-input-number>
                        </div>
                    </div>
                </div>
                <div v-if="outPager.total" class="flex justify-center mt-6">
                    <el-pagination background layout="prev, pager, next" :total="outPager.total"
                        @current-change="loadMoreOut"></el-pagination>
                </div>
                <div v-else class="mt-60">
                    <img :src="require(`@/assets/image/暂无收藏.png`)" class="mx-auto" />
                </div>
                <div class="mt-4 text-center">
                    <el-button @click="isRproductEdit = false">{{ $t('取消') }}</el-button>
                    <el-button type="primary" @click="addRrpdocut">+{{ $t('确认添加') }}</el-button>

                </div>
            </el-dialog>
        </el-dialog>
        <goodslist :show="showSelect" @close="showSelect = false" @getCurPProduct="getCurPProduct"></goodslist>
        <productedit :show="showEdit" @close="showEdit = false" :product="product" :pid="curPid" :isCopy="isCopy"
            @reload="loadData"></productedit>
    </div>

</template>
<script>
import Search from "@/components/mine/search.vue";
import goodslist from "@/components/supplier/goodslist.vue"
import productedit from "@/components/supplier/productedit.vue"

export default {
    components: { Search, goodslist, productedit },
    data() {
        return {
            curGenre: 'bundled',
            pgenre: [
                {
                    key: 'one',
                    name: this.$t('单扎花材'),
                },
                {
                    key: 'bundled',
                    name: this.$t('整箱花材'),
                },
            ],
            curTab: 'normal',
            pager: new this.$Pager({
                apiname: 'sup/getOnShelvesProducts',
                param: () => ({
                    tag: this.curTab,
                    wh: this.curWh,
                    q__name__icontains: this.keyword,
                    genre: this.curGenre,
                }),
                // size: 2,
                onLoaded: (res) => {
                    if (res && res.data && res.data.items) {
                        res.data.items.forEach(item => {
                            item._select = false
                        })
                    }
                }
            }),
            keyword: '',
            count: {},

            ruleKeyword: '',
            isRulesEdit: false,
            rulePager: this.$Pager({
                apiname: 'sup/getProductPriceRules',
                param: () => ({
                    keyword: this.ruleKeyword,
                    tag: this.curRuleTab
                })
            }),
            ruleTabs: [{
                key: '',
                name: this.$t('默认规则')
            },
            {
                key: 'diy',
                name: this.$t('自定义规则')
            }
            ],
            curRuleTab: '',
            pid: '',
            isBatch: false,
            isRproductEdit: false,
            isShowRproducts: false,
            curRproduct: {},
            subTitles: [this.$t('关联商品'), this.$t('数量'), this.$t('上架售价'), this.$t('操作')],
            ppid: '',
            outKeryword: '',
            pproducts: [],
            outPager: this.$Pager({
                apiname: 'sup/getOutProducts',
                param: () => ({
                    ppid: this.ppid,
                    keyword: this.outKeryword,
                }),
                onLoaded: (res) => {
                    if (res.data?.start == 0 && res.data.pproducts) {
                        this.pproducts = res.data.pproducts
                    }
                }
            }),
            outTitles: [
                this.$t('上架售价'),
                this.$t('库存'),
                this.$t('重量')
            ],
            showSelect: false,
            showEdit: false,
            curPid: 0,
            isCopy: false,
            product: {}

        }
    },
    mounted() {
        this.loadData()
    },
    computed: {
        titles() {
            return [
                this.$t('商品'),
                this.$t('库存'),
                this.$t('当前价格'),
                this.$t('加价规则'),
                this.$t('上架售价'),
                this.$t('状态'),
                this.curGenre == 'bundled' ? this.$t('关联商品') : '',
                this.$t('操作'),
            ].filter(o => o)
        },
        tabs() {
            return [{
                key: 'saling',
                name: this.$t('在售中'),
                num: this.count?.on_count || 0
            },
            {
                key: 'stock0',
                name: this.$t('已售罄'),
                num: this.count?.sold_out_count || 0
            },
            {
                key: 'normal',
                name: this.$t('已下架'),
                num: this.count?.off_count || 0
            },
            {
                key: 'lock',
                name: this.$t('已锁定'),
                num: this.count?.lock_count || 0
            }
            ]
        },
        selectIds() {
            let res = []
            this.pager.items.forEach(item => {
                if (item._select) {
                    res.push(item.id)
                }
            })
            return res
        },
        selectLen() {
            let len = this.selectIds.length

            return len;
        },
        isSelectAll() {
            return this.selectLen && this.selectLen == this.pager.items.length
        },
        batchBtns() {
            return [
                {
                    key: 'addprice',
                    name: '改加价',
                    type: 'primary'
                },
                ((this.curTab == 'normal') || (this.curTab == 'stock0')) && {
                    key: 'on',
                    name: '上架',
                    type: 'primary'

                },
                (this.curTab == 'saling' || (this.curTab == 'stock0')) && {
                    key: 'off',
                    name: '下架',
                    type: 'warning'

                },
                this.curTab != 'lock' && {
                    key: 'lock',
                    name: '锁定',
                    type: 'danger'
                },
                {
                    key: 'cancel',
                    name: '取消'
                }
            ].filter(o => o)
        }

    },
    watch: {
        'curTab': {
            handler(newVal) {
                this.loadData()
            }
        },
        'curGenre': {
            handler(newVal) {
                this.loadData()
            }
        },
        curRuleTab(v) {
            this.rulePager.first()
        }
    },
    methods: {
        loadData() {
            this.pager.first()
            this.getCount()
        },
        async doShelves(item, key) {
            let action = null
            let text = null
            if (key == 'lock') {
                action = 'lock'
                text = this.$t('您正在锁定此商品，请谨慎操作，锁定的商品只能联系客服解锁')
            } else {
                switch (item.status) {
                    case 0:
                        action = 'on'
                        text = this.$t('您需要上架此商品?')
                        break;
                    case 10:
                        action = 'off'
                        text = this.$t('您正在下架该商品?')
                        break;

                }
            }

            let query = await this.$query(text)
            if (!query) return
            let res = await this.$callapi('sup/doShelves', {
                action: action,
                pid: item.id
            })
            if (res.code == 0 && res.data) {
                this.$toast(this.$t('操作成功'), 'success')
                // let index = this.pager.items.findIndex(i => i.id == res.data.pid)
                // // console.log(index);
                // this.pager.items.splice(index, 1)
                this.loadData()
            }
        },
        async delProduct(id) {
            let query = await this.$query(this.$t('您确定需要删除此商品?'))
            if (!query) return
            let res = await this.$callapi('sup/deleteProduct', {
                pid: id
            })
            if (res.code == 0 && res.data) {
                this.$toast(this.$t('删除成功'))
                let index = this.pager.items.findIndex(i => i.id == res.data.pid)
                this.pager.items.splice(index, 1)
            }
        },
        async getCount() {
            let res = await this.$callapi('sup/getProductCount', {
                wh: this.curWh,
                genre: this.curGenre,
            })
            if (res.code == 0 && res.data) {
                this.count = res.data
            }
        },
        async editProduct() {
            let {
                id,
                stock,
                price,
                curPrice,
                curStock
            } = this.curProduct
            let param = {
                pid: id
            }
            if (this.curType == 'price') {
                if (!curPrice) {
                    return this.$toast(this.$t('请输入价格'))
                }

                param.stock = stock
                param.price = this.$transCNY(curPrice)
            } else if (this.curType == 'stock') {
                if (!curStock) {
                    return this.$toast(this.$t('请输入库存'))
                }
                param.price = price
                param.stock = parseInt(curStock)
            }
            // return
            // console.log(this.curProduct);
            this.$doing()
            let res = await this.$callapi('sup/addOrUpdateProduct', param)
            this.$done()
            if (res.code == 0 && res.data) {
                this.curProduct = null
                await this.loadData()
                await this.$toast(this.$t('操作成功'), 'success')
            }
        },
        tapSelect(item) {
            item._select = !item._select
        },
        selectAll() {
            let flag = !this.isSelectAll
            this.pager.items.forEach(spu => {
                spu._select = flag
            })
            console.log(this.isSelectAll);
        },

        async setBatch(key) {
            switch (key) {
                case 'addprice': {
                    if (!this.selectLen) {
                        return this.$toast('请选择商品')
                    }
                    this.addPrice(this.selectIds.join(','), 'batch')
                    break;
                }

                case 'on':
                case 'off':
                case 'lock':
                    {
                        if (!this.selectLen) {
                            return this.$toast('请选择商品')
                        }
                        let actionText = ''
                        if (key == 'on') {
                            actionText = this.$t('确定要对所选商品进行上架操作吗?')
                        } else if (key == 'off') {
                            actionText = this.$t('确定要对所选商品进行下架操作吗?')
                        } else {
                            actionText = this.$t('您正在锁定商品，请谨慎操作，锁定的商品只能联系客服解锁')

                        }
                        let r = await this.$query(actionText)
                        if (!r) return
                        let param = {
                            'pids': this.selectIds,
                            'action': key,
                            'genre': this.curGenre,
                        }
                        this.$doing()
                        let res = await this.$callapi('sup/doBatchShelves', param)
                        this.$done()
                        if (res.code == 0 && res.data) {
                            await this.$toast(this.$t('操作成功'), 'success')
                            this.loadData()
                        }
                        break;
                    }
                case 'cancel':
                    {
                        this.isBatch = false
                        break;
                    }


            }

        },

        async delBundleProduct(index, item) {
            item.bundles.splice(index, 1)
            let param = {
                pid: item.id,
                stock: item.stock,
                price: item.price,
                bundles_json: JSON.stringify(item.bundles.map(arr => { return { pid: arr.id, quantity: arr.quantity } }))
            }
            this.$doing()
            let r = await this.$callapi('sup/addOrUpdateProduct', param)
            this.$done()
            if (r.code == 0 && r.data) {
                this.$toast(this.$t('删除成功'))
                await this.loadData()
            }
        },
        async addPrice(id, key) {
            if (key == 'batch') {
                this.pids = id
            } else {
                this.pid = id
            }

            await this.rulePager.first()
            this.isRulesEdit = true

        },
        async loadMoreRules(e) {
            await this.rulePager.load(e)
        },
        pageChange(e) {
            this.pager.load(e)
        },
        search(e) {
            this.keyword = e
            this.loadData()
        },
        searchRule(e) {
            this.ruleKeyword = e
            this.rulePager.first()
        },
        async apply(id) {
            let r = await this.$query(this.$t('确定应用此加价规则'))
            if (!r) return
            this.$doing()
            let api = 'sup/setProductPriceRule'
            let param = {
                pid: this.pid,
                ruleid: id
            }
            if (this.pids) {
                param = {
                    pids: this.pids,
                    ruleid: id
                }
            }
            let res = await this.$callapi(api, param)
            this.$done()
            if (res.code == 0) {
                await this.$toast(this.$t('应用成功'), 'success')
                await this.pager.load()
                this.isRulesEdit = false
            }

        },
        async loadMoreOut(e) {
            await this.outPager.load(e)
        },
        getCurPProduct(item) {
            this.showEdit = true
            this.product = JSON.parse(item)
        },
        // 单个商品上头操作
        setProduct(item, key) {
            switch (key) {
                case 'stock':
                    {
                        this.$prompt(this.$t('请输入库存'), item.name, {
                            confirmButtonText: this.$t('确定'),
                            cancelButtonText: this.$t('取消'),
                            inputPattern: /^(0|[1-9]\d*)$/,
                            inputErrorMessage: this.$t('库存只能为0或正整数')
                        }).then(async (val) => {
                            let res = await this.$callapi('sup/addOrUpdateProduct', {
                                pid: item.id,
                                stock: val.value
                            })
                            if (res.code == 0) {
                                this.loadData()
                            }

                        })
                        break;
                    }
                case 'edit':
                    {
                        this.curPid = item.id
                        this.showEdit = true
                        break;
                    }
            }
        },
        // 设置关联商品
        async selectRproduct() {
            await this.outPager.first()
            this.isRproductEdit = true
        },
        setRproductNum(item, e) {

            this.$set(item, 'selected', e > 0 ? true : false)


        },
        setRproduct(item, e) {
            if (e) {
                this.$set(item, 'quantity', item.quantity || 1)
            } else {
                this.$set(item, 'quantity', 0)
            }

        },
        async addRrpdocut() {
            let selectedItems = this.outPager.items.filter(item => item.selected)
            if (!selectedItems.length) {
                return this.$toast(this.$t('请选择商品'))
            }

            let arrs = []
            let item = this.curRproduct
            selectedItems.forEach(r => {
                let index = item.bundles.findIndex(iitem => iitem.id == r.id)
                if (index > -1) {
                    item.bundles.splice(index, 1)
                }
            })
            arrs = item.bundles.concat(selectedItems)
            let param = {
                pid: item.id,
                stock: item.stock,
                price: item.price,
                bundles_json: JSON.stringify(arrs.map(arr => { return { pid: arr.id, quantity: arr.quantity } }))
            }
            this.$doing()
            let r = await this.$callapi('sup/addOrUpdateProduct', param)
            this.$done()
            if (r.code == 0 && r.data) {
                await this.loadData()
                await this.$toast(this.$t('添加成功'), 'success')
                this.isRproductEdit = false
                this.isShowRproducts = false
            }

        },
        async delRproduct(index) {
            this.curRproduct.bundles.splice(index, 1)
            let param = {
                pid: this.curRproduct.id,
                stock: this.curRproduct.stock,
                price: this.curRproduct.price,
                bundles_json: JSON.stringify(this.curRproduct.bundles.map(arr => { return { pid: arr.id, quantity: arr.quantity } }))
            }
            this.$doing()
            let r = await this.$callapi('sup/addOrUpdateProduct', param)
            this.$done()
            if (r.code == 0 && r.data) {
                this.$toast(this.$t('删除成功'), 'success')
            }
        },
        async searchOutProudct(e) {
            this.outKeryword = e
            await this.outPager.first()
        }
    }
}
</script>
<style scoped lang="scss">.el-tabs ::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent;
}
.tab {
  height: 2.063rem;
  padding: 0 0.875rem;
  border: 0.063rem solid #e0e0e0;
  line-height: 2.063rem;
}
.tab.active {
  border-color: #34B66B;
  color: #34B66B;
}
.layout {
  display: grid;
  grid-template-columns: 35% 18% 16% 14% auto;
}
.tr {
  display: grid;
  grid-template-columns: 1fr 1.2fr repeat(5, 1fr) 1.3fr;
}
.tr.bundled {
  grid-template-columns: 1fr 1.2fr repeat(6, 1fr) 1.3fr;
}
.titles {
  background-color: #F4F4F5;
  height: 2rem;
  align-items: center;
  margin-top: 1.063rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.product {
  border: 0.063rem solid #e4e4e4;
  margin-top: 0.625rem;
}
.product>div:not(:first-child) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  border-left: 0.063rem solid #e4e4e4;
}
.product>div.bundled {
  padding: 0.5rem;
  grid-template-columns: repeat(2, 1fr);
  display: -ms-grid;
  display: grid;
}
.product .img-box {
  display: grid;
  grid-template-columns: 2rem 4.5rem auto;
  grid-column-gap: 0.563rem;
  padding: 0.688rem 0 0.813rem 0.938rem;
  grid-column: 1/3;
  justify-items: flex-start;
}
.product .img-box .img {
  width: 4.5rem;
  height: 4.5rem;
  grid-row: 1/3;
  grid-column: 2/3;
}
.product .img-box .attrs {
  grid-row: 2/3;
  grid-column: 3/4;
}
.product .rule {
  color: #F95623;
  background: #f956231a;
  border-radius: 0.125rem;
  padding: 2px 4px;
}
.rules .rule {
  grid-template-columns: 2fr 1fr;
  border: 0.1rem solid #d4d4d4;
  margin-bottom: 0.62rem;
}
.rules .rule .edit {
  color: #4B81D1;
}
.main-product {
  display: -ms-grid;
  display: grid;
  justify-items: start;
  -webkit-column-gap: 0.5rem;
  -moz-column-gap: 0.5rem;
  grid-column-gap: 0.5rem;
  column-gap: 0.5rem;
  grid-template-columns: 4.5rem auto;
}
.main-product img {
  grid-row-start: 1;
  grid-row-end: 4;
}
.r-table {
  margin-top: 1rem;
}
.r-table .r-tr {
  display: -ms-grid;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  justify-items: center;
}
.r-table .r-tr.th {
  height: 2.25rem;
  background: #f4f4f5;
}
.r-table .r-tr.td {
  border: 0.063rem solid #e4e4e4;
  margin-top: 0.5rem;
}
.r-table .r-tr.td>span {
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 4.375rem;
  width: 100%;
}
.r-table .r-tr.td>span:not(:last-child) {
  border-right: 0.063rem solid #e4e4e4;
}
.pproducts {
  margin-right: 2rem;
  overflow-x: scroll;
  white-space: nowrap;
}
.pproducts>span {
  cursor: pointer;
  margin-right: 1.25rem;
  white-space: nowrap;
}
.out-table {
  margin-top: 1.25rem;
}
.out-table .out-tr {
  display: -ms-grid;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr;
  place-items: center;
}
.out-table .out-tr.th {
  height: 2.25rem;
  background: #f4f4f5;
}
.out-table .out-tr.td {
  border: 0.063rem solid #e4e4e4;
  margin-top: 0.5rem;
}
.out-table .out-tr.td>div {
  height: 100%;
  width: 100%;
  padding: 0.75rem 1.2rem;
}
.out-table .out-tr.td>div:not(:last-child) {
  border-right: 0.063rem solid #e4e4e4;
}
.out-table .out-tr.td>div:not(:first-child) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.out-table .out-tr.td>div:first-child {
  display: grid;
  grid-template-columns: 2rem 3.68rem auto;
  grid-column-gap: 0.563rem;
  justify-items: flex-start;
  justify-self: flex-start;
}
.out-table .out-tr.td>div:first-child img {
  width: 3.68rem;
  height: 3.68rem;
  grid-row: 1/3;
  grid-column: 2/3;
  border-radius: 0.13rem;
}
.out-table .out-tr.td>div:first-child .attrs {
  grid-row: 2/3;
  grid-column: 3/4;
}</style>